import { render, staticRenderFns } from "./portContacts.vue?vue&type=template&id=7dd4271c"
import script from "./portContacts.vue?vue&type=script&lang=js"
export * from "./portContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports